import ListingSkeleton from './ListingSkeleton'

export default ListingSkeleton
